export default __webpack_public_path__ + "69d9fa885705148f32ae6cd55d9f8d52.svg";